import { querySelectorAll } from '../helpers'

export function initializeHomepageQuicklinks(selector: string) {
  const quicklinks = document.querySelector(selector)
  if (quicklinks) {
    const elements = querySelectorAll('.element', quicklinks)
    const selectElement = (selectedIndex: number) => {
      elements.forEach((el, index) => {
        el.classList.toggle('active', selectedIndex === index)
      })
    }
    const createDropdownFilter = () => {
      const container = quicklinks.querySelector('.list-element__container')
      if (container) {
        const filter = document.createElement('div')
        filter.className = 'list-element__select'
        const title = document.createElement('h4')
        title.innerText = 'Helpful quicklinks for'
        filter.appendChild(title)
        const dropdown = document.createElement('select')
        elements.forEach((el, index) => {
          const heading = el.querySelector('h4')
          if (heading) {
            const headingText = heading.innerText.toLowerCase()
            const option = document.createElement('option')
            option.value = headingText
            option.innerText = headingText
            dropdown.appendChild(option)
            if (index === 0) {
              dropdown.selectedIndex = 0
            }
          }
        })
        dropdown.addEventListener('change', e => {
          selectElement(dropdown.selectedIndex)
        })
        filter.appendChild(dropdown)
        container.insertBefore(filter, container.firstChild)
      }
    }
    selectElement(0)
    createDropdownFilter()
  }
}
